// ============ Mobile nav toggle ============
document.addEventListener('DOMContentLoaded', function () {
  var navToggle = document.getElementById('navToggle');
  var navDesktop = document.querySelector('.nav-desktop');
  if (navToggle && navDesktop) {
    navToggle.addEventListener('click', function () {
      var open = navDesktop.style.display === 'flex';
      navDesktop.style.display = open ? 'none' : 'flex';
      navDesktop.style.position = 'absolute';
      navDesktop.style.top = '78px';
      navDesktop.style.left = '0';
      navDesktop.style.right = '0';
      navDesktop.style.background = 'var(--warm-white)';
      navDesktop.style.flexDirection = 'column';
      navDesktop.style.padding = '20px 24px';
      navDesktop.style.boxShadow = 'var(--shadow-soft)';
      navDesktop.style.zIndex = '40';
    });
  }

  // ============ FAQ accordion (shared: homepage FAQ + product page FAQ) ============
  document.querySelectorAll('.faq-question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.faq-item');
      var wasOpen = item.classList.contains('open');
      item.parentElement.querySelectorAll('.faq-item').forEach(function (i) { i.classList.remove('open'); });
      if (!wasOpen) item.classList.add('open');
    });
  });

  // ============ Sticky mobile cart bar ============
  var mobileCartBar = document.getElementById('mobileCartBar');
  function updateMobileCartBar() {
    if (!mobileCartBar) return;
    var isMobile = window.innerWidth <= 768;
    var scrolledPastHero = window.scrollY > window.innerHeight * 0.6;
    mobileCartBar.classList.toggle('active', isMobile && scrolledPastHero);
  }
  window.addEventListener('scroll', updateMobileCartBar);
  window.addEventListener('resize', updateMobileCartBar);
  updateMobileCartBar();
});
